export const lastUpdatedDate = 1748249908089;